import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";

import { AppDispatch, RootState } from "../../store";
import { getAllMasters } from "../../store/actions/MasterActions";
import {
  fetchCurrentUser,
  fetchTenantsData,
} from "../../store/actions/UserActions";
import { getPODs } from "../../store/actions/PODActions";
import { fetchTableauToken } from "../../services/login";
import { getDashboardStats } from "../../store/actions/DashboardActions";
import { TableauPortal } from "../Dashboard/TableauPortal";
import classes from "./Home.module.css";
import Sidebar from "../Sidebar/Sidebar";

const Home: React.FC<{}> = () => {
  const dispatch: AppDispatch = useDispatch();
  const { tableauTab } = useSelector((state: RootState) => state.auth);
  const [token, setToken] = useState("");

  useEffect(() => {
    dispatch(getAllMasters());
    dispatch(getPODs());
    dispatch(fetchCurrentUser());
    dispatch(getDashboardStats());
    dispatch(fetchTenantsData());
  }, [dispatch]);

  const getTableauToken = async () => {
    try {
      const res = await fetchTableauToken();
      if (res.data.success) {
        setToken(res.data.token);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!token && tableauTab === "Analytics") {
      getTableauToken();
    }
  }, [tableauTab, token]);

  useEffect(() => {
    const root = document.getElementById("tableau-container-root");
    if (!root) return;

    if (tableauTab === "Analytics") {
      root.style.display = "block";
    } else {
      root.style.display = "none";
    }
  }, [tableauTab]);

  return (
    <>
      <div className={classes.main}>
        <div className={classes.left}>
          <Sidebar />
        </div>
        <div className={classes.right}>
          <Outlet context={{ setToken }} />
        </div>
      </div>
      <div style={{ display: tableauTab === "Analytics" ? "block" : "none" }}>
        {!!token && <TableauPortal token={token} />}
      </div>
    </>
  );
};

export default Home;
